// extracted by mini-css-extract-plugin
export default {"addTextButtonWrapper":"ButtonAddText_addTextButtonWrapper__dADPL","addTextButton":"ButtonAddText_addTextButton__98WXz"};